import React from 'react';
import { StyleSheet, Text, View } from '@react-pdf/renderer';

const styles = StyleSheet.create({
    page: {
        width: '100%',
        marginTop: '20px',
        fontSize: 12,
        flexDirection: 'column',
    },
    section: {
        width: '100%',
    },
    row: {
        width: '100%',
        flexDirection: 'row',
        alignItems: 'center',
        marginBottom: '5px',
    },
    descricao: {
        fontSize: 11,
        flexShrink: 0,
    },
});

const Table = ({ children }) => <View style={styles.page}>{children}</View>;

const TableHead = ({ children }) => <View style={styles.section}>{children}</View>;

const TableBody = ({ children }) => <View style={styles.section}>{children}</View>;

const TableRow = ({ children }) => <View style={styles.row}>{children}</View>;

const TableCell = ({ children, width = '20%', align = 'left' }) => (
    <Text style={{ ...styles.descricao, width, textAlign: align }}>
        {children}
    </Text>
);

export { Table, TableRow, TableHead, TableCell, TableBody };
